import type { LeaderboardTimeFrame } from '../types/types'

/**
 * Leaderboard TanStack query key factory — keep in sync with leaderboard.query-store usage.
 */
export const leaderboardQueryKeys = {
  // Root prefix only — locationId sits before groupId on leaf keys, so a groupId-scoped
  // prefix cannot match. Callers invalidate the whole leaderboard namespace after membership changes.
  all: () => ['leaderboard'] as const,
  groupLeaderboard: (groupId: string, locationId: string, timeFilter?: LeaderboardTimeFrame) =>
    ['leaderboard', locationId, groupId, 'group', timeFilter] as const,
  groupMembersLevelDistribution: (groupId: string, locationId: string) =>
    ['leaderboard', locationId, groupId, 'members-level-distribution'] as const,
} as const
